// The state store's own health, always visible, never behind a click (DESIGN D6: "store line (store.self, always
// visible)"), judged by the server on the OLDEST scheduled entry. The per-monitor last writes are in the Monitors
// registry below.
import type { HealthResponse } from "./types";
import { CheckTile } from "./Tiles";
import { fmtUtc, plural } from "./present";

export function StoreLine({ data }: { data: HealthResponse }) {
  const s = data.store;
  const scheduled = s.entries.filter(e => e.trigger !== "push").length;
  return (
    <section className="ph-store" aria-labelledby="ph-store-title" data-testid="store-line">
      <div className="ph-store-head">
        <h2 id="ph-store-title">STATE STORE</h2>
        <span className="ph-hint">
          {s.location} · read {fmtUtc(s.read_at_utc)} · {s.read_ok ? "read OK" : "READ FAILED"}
        </span>
      </div>
      {!s.read_ok ? (
        <p className="ph-reason" data-testid="store-read-error">
          The store could not be read: {s.read_error?.trim() || "the server gave no error text"}
        </p>
      ) : null}
      <div className="ph-store-self" data-testid="store-self">
        <CheckTile
          tile={s.self}
          keyOverride="store::self"
          coverageOverride={`${plural(scheduled, "scheduled entry", "scheduled entries")} judged on the oldest · ${plural(
            s.excluded.length,
            "push-triggered monitor"
          )} excluded`}
        />
      </div>
    </section>
  );
}
